let global_map;
let gsgdb_location_searchBox;
let global_clusterer;
let global_pois = [];

// Bounding box, damit Österreich vollständig im Kartenausschnitt sichtbar ist.
const GSGDB_AUSTRIA_BOUNDS = [
    [46.35, 9.5],
    [49.05, 17.2],
];

function initMap() {
    global_map = L.map('wps-complex-search-map', {
        zoomControl: false,
    });
    global_map.fitBounds(GSGDB_AUSTRIA_BOUNDS, { padding: [20, 20] });

    L.control.zoom({ position: 'bottomright' }).addTo(global_map);

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
        maxZoom: 16,
    }).addTo(global_map);

    global_clusterer = L.markerClusterGroup({
        maxClusterRadius: 30,
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        iconCreateFunction(cluster) {
            return L.divIcon({
                html: `<span>${cluster.getChildCount()}</span>`,
                className: 'wpscs-cluster-icon',
                iconSize: [65, 66],
            });
        },
    });
    global_map.addLayer(global_clusterer);

    // #gsgdbmapwrapper's height comes from Bootstrap's row.align-items-stretch
    // matching the sibling search-panel column, which can still be reflowing
    // (webfonts, filter UI) after Leaflet has already measured the container -
    // without this, that late resize leaves the map cropped/misaligned until
    // the next manual interaction forces a redraw.
    new ResizeObserver(() => global_map.invalidateSize()).observe(
        document.getElementById('wps-complex-search-map')
    );

    initAutocomplete();
    initGeolocation();
}

// Adress-Autocomplete über Photon (photon.komoot.io) - ein auf OpenStreetMap-Daten
// basierender, keyless Geocoder, der (anders als Nominatim) explizit für
// Live-Autocomplete-Anfragen während des Tippens gedacht ist.
const GSGDB_GEOCODE_COUNTRIES = ['at', 'de', 'hu', 'cz', 'ch', 'it', 'si', 'sk'];

function initAutocomplete() {
    const input = document.getElementById('pac-input');
    if (!input) return;

    // Wrapper so the results list can anchor to the input's own (unknown until
    // rendered) height via top:100% instead of a hardcoded pixel offset.
    const wrapper = document.createElement('div');
    wrapper.className = 'gsgdb-geosuggest';
    input.replaceWith(wrapper);
    wrapper.appendChild(input);

    const results = document.createElement('ul');
    results.className = 'gsgdb-geosuggest-results';
    wrapper.appendChild(results);

    let debounceTimer;
    let activeController;

    function clearResults() {
        results.replaceChildren();
    }

    async function search(query) {
        if (activeController) activeController.abort();
        activeController = new AbortController();

        const url = `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&lat=47.6&lon=14.2&limit=8&lang=de`;

        let data;
        try {
            data = await fetch(url, { signal: activeController.signal }).then((r) => r.json());
        } catch (e) {
            return; // Netzwerkfehler oder durch neuere Eingabe abgebrochen - einfach nichts anzeigen.
        }

        const features = (data.features || []).filter((f) =>
            GSGDB_GEOCODE_COUNTRIES.includes((f.properties.countrycode || '').toLowerCase())
        );

        clearResults();
        for (const feature of features) {
            const p = feature.properties;
            const label = [p.name, p.street, p.city, p.country].filter(Boolean).join(', ');

            const li = document.createElement('li');
            li.textContent = label;
            li.addEventListener('click', () => selectFeature(feature, label));
            results.appendChild(li);
        }
    }

    function selectFeature(feature, label) {
        input.value = label;
        clearResults();

        const [lon, lat] = feature.geometry.coordinates;
        const extent = feature.properties.extent; // Photon-Reihenfolge: [minLon, maxLat, maxLon, minLat]

        if (extent) {
            global_map.fitBounds([
                [extent[3], extent[0]],
                [extent[1], extent[2]],
            ]);
        } else {
            global_map.setView([lat, lon], 13);
        }
    }

    input.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        const query = input.value.trim();
        if (query.length < 3) {
            clearResults();
            return;
        }
        debounceTimer = setTimeout(() => search(query), 300);
    });

    document.addEventListener('click', (e) => {
        if (e.target !== input && !results.contains(e.target)) {
            clearResults();
        }
    });

    gsgdb_location_searchBox = input;
}

function initGeolocation(enable = false) {
    if (!enable || !navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(({ coords }) => {
        const position = [coords.latitude, coords.longitude];
        global_map.setView(position, 13);
        L.marker(position).addTo(global_map);
    });
}

// Kein Google-Bootstrap-Skript mehr, das per callback=initMap ruft - selbst anstoßen.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMap);
} else {
    initMap();
}
